// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2NB1i","primary":"style_primary__3dZOU","secondary":"style_secondary__3s6Bs","danger":"style_danger__7zw80","large":"style_large__3RPBH"};